// extracted by mini-css-extract-plugin
export default {"buttons":"widgetconfig_buttons__4lbKh"};